<template>
  <div class="e-block-wrap">
    <div class="e-block">
      <div class="e-block__scroll e-block__scroll--map" :style="{ minHeight: containerHeight }">
        <div class="e-map-step">
          <div class="e-searchBlock">
            <div class="e-searchBlock__title">Where is your home located?</div>
            <div class="e-searchBlock__row">
              <input type="text"
                     class="e-searchBlock__input"
                     :class="{'e-searchBlock__input--error': hasError}"
                     placeholder="ZIP code"
                     maxlength="5"
                     @keydown="isNumber"
                     v-model="zipCode">
              <img src="@/assets/img/loader-animation.gif" alt="..." class="e-searchBlock__input-img" v-if="loading">
              <div class="e-input__hint e-input__hint--error" v-if="hasError">Please enter a valid zip code in the US</div>
            </div>
            <div class="e-searchBlock__row">
              <button class="e-searchBlock__btn" @click.prevent="searchByZip" :disabled="hasError || zipCode.length < 5 || loading">Search</button>
            </div>
          </div>
          <div class="e-map-wrap">
            <l-map
              id="mapContainer"
              ref="map"
              :center="centerCoordinates"
              :options="mapOptions"
              @popupclose="closePopup"
            >
              <l-tile-layer
                :url="url"
                :options="options"
              />
              <l-marker
                v-for="(marker, index) in markers"
                :key="index"
                :lat-lng="marker.latLng"
                :icon="marker.icon"
                @click="selectMarker(marker)"
                :ref="marker.ref"
              >
                <l-popup class="e-popup" :options="popupOptions">
                  <div class="e-popup__content">
                    <div class="e-popup__title">
                      {{ marker.title }}
                      <div class="e-popup__text">{{ marker.state }}</div>
                    </div>
                    <div class="e-popup__temp">{{ marker.temp }}°F</div>
                    <div class="e-popup__btn-wrap">
                      <a href="#" @click.prevent="proceed(marker)" class="e-popup__btn">Proceed</a>
                    </div>
                  </div>
                </l-popup>
              </l-marker>

            </l-map>
          </div>
        </div>
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row">
        <div class="e-col-auto e-col-sm-12">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { latLng } from 'leaflet';
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
} from 'vue2-leaflet';
import { mapActions, mapGetters, mapState } from 'vuex';
import { defaultIcon, selectedIcon } from '@/store';
import { getClosestLocation } from '@/api/eemaxApi';

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  name: 'Map',
  data() {
    return {
      zipCode: '',
      centerCoordinates: latLng(37.8, -96),
      mapOptions: {
        zoomSnap: 0.5,
        zoom: 5,
        zoomControl: false,
      },
      searchIsSuccess: false,
      url: 'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
      options: {
        maxZoom: 20,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      },
      popupOptions: {
        offset: [75, 200],
      },
      hasError: false,
      loading: false,
    };
  },
  mounted() {
    if (this.isMobile) {
      this.popupOptions.offset = [0, 170];
      this.popupOptions.keepInView = true;
    }
  },
  computed: {
    ...mapState(['isMobile', 'markers', 'containerHeight']),
    ...mapGetters(['currentQuestion']),
  },
  methods: {
    ...mapActions(['nextQuestion', 'previousQuestion', 'addParamToFilter', 'setSelectedZip']),
    closePopup() {
      const prevItem = this.markers.find((marker) => marker.selected);
      if (prevItem) {
        prevItem.selected = false;
        prevItem.icon = defaultIcon;
      }
    },
    selectMarker(item) {
      item.selected = true;
      item.icon = selectedIcon;
    },
    async searchByZip() {
      this.loading = true;
      try {
        const data = await getClosestLocation(this.zipCode);
        if (data && data.ID) {
          this.$refs.map.mapObject.flyTo(latLng(data.Lat, data.Lon), 7);
          const item = this.markers.find((marker) => marker.id === data.ID);
          if (item) {
            item.selected = true;
            item.icon = selectedIcon;
            this.$refs[item.ref][0].mapObject.openPopup();
          }
          this.searchIsSuccess = true;
        } else {
          this.hasError = true;
        }
      } catch (e) {
        this.hasError = true;
      }
      this.loading = false;
    },
    isNumber(evt) {
      evt = (evt) || window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode === 13 && this.zipCode.length === 5) {
        this.searchByZip();
        return false;
      }
      if (charCode >= 96 && charCode <= 105) {
        charCode -= 48;
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && [46, 37, 39, 8].indexOf(charCode) < 0) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
    proceed(marker) {
      this.addParamToFilter({ name: this.currentQuestion.paramName, value: +(marker.temp) });
      this.nextQuestion(this.currentQuestion.nextId);
      if (this.searchIsSuccess) {
        this.setSelectedZip(this.zipCode);
      } else {
        this.setSelectedZip(marker.zipCode);
      }
    },
    previous() {
      this.previousQuestion();
    },
  },
  watch: {
    zipCode() {
      this.hasError = false;
      this.searchIsSuccess = false;
    },
  },
};
</script>

<style lang="scss">

</style>
